import React, { useState, useEffect } from 'react';
import Checkbox from "../Checkbox";
import {getValueOfPermissions, handleChangePermission} from "./rolesUtil";

const BusinessObjectPermissionItem = ({role, rolePermission, permissionKey}) => {
    const [isActive, setIsActive] = useState(false);
    const getIsActive = () => {
        return role.permissions.length ? getValueOfPermissions(role.permissions, rolePermission.entryPoint, permissionKey) : false;
    };
    const handleIsActive = (checked) => {
        setIsActive(!isActive);
        handleChangePermission(checked, role, permissionKey, rolePermission);
    };
    useEffect(() => {
        setIsActive(getIsActive());
    }, [role, rolePermission, permissionKey]);
    return (
        <Checkbox handleChecked={handleIsActive} checked={isActive} />
    );
};

export default BusinessObjectPermissionItem;
